import { IVendorConfig } from '@rbi-ctg/menu';

export const isVendorConfig = (value: unknown): value is IVendorConfig =>
  typeof value === 'object' && value !== null && 'pluType' in value;

export const findVendorConfig = (
  configs: object | null | undefined,
  vendor: string
): IVendorConfig | undefined => {
  if (!configs) {
    return undefined;
  }
  const entry = Object.entries(configs).find(
    ([key, value]) => key === vendor && isVendorConfig(value)
  );
  return entry ? (entry[1] as IVendorConfig) : undefined;
};
